import * as def from '@/definitions'
import { Layer } from './layer';
import { ObjectLayer } from './objectLayer';
import { UuidHelper } from '@/helper/uuidHelper';

// バーコードレイヤー
export class BarcodeLayer extends ObjectLayer
{
    public get layerType() : string { return "barcode"; }

    //! FILE_VERSION == 3 で追加
    //! モバイル版に使用するパラメータ
    // 固定タイプ
    // 0: 縦横固定 
    // 1; 縦固定 
    // 2: 横固定 
    private _keepRatio : number = 0;
    public get keepRatio() : number
    {
        return this._keepRatio;
    }
    public set keepRatio(keepRatio : number)
    {
        this._keepRatio = keepRatio;
    }

    // 入力文字
    private _text : string = "";
    public get text() { return this._text; }
    public set text(text) { this._text = text; }

    // バーコードタイプ
    // 0: JAN(標準) (EAN-13)
    // 1: JAN(短縮) (EAN-8)
    // 2: 物流(標準) (ITF-14)
    // 3: 物流(拡張) (ITF)
    // 4: 物流(アドオン) (ITF)
    // 5: ITF (ITF)
    // 6: NW-7 (Codabar)
    // 7: CODE39 (CODE39)
    // 8: CODE128 (CODE128)
    private _barcodeType : number = 0;
    public get barcodeType() { return this._barcodeType; }
    public set barcodeType(barcodeType) { this._barcodeType = barcodeType; }

    // テキスト表示するか
    private _showNumber : boolean = true;
    public get showNumber() { return this._showNumber; }
    public set showNumber(showNumber) { this._showNumber = showNumber; }

    // 作成
    public static create(barcodeType : number, text : string, x : number = 0, y : number = 0, width : number = 0, height : number = 0) : BarcodeLayer
    {
        var layer = new BarcodeLayer();
        layer.width = width;
        layer.height = height;
        layer.x = x;
        layer.y = y;
        layer.barcodeType = barcodeType;
        layer.text = text;
        layer.insertionId = UuidHelper.getUuid();

        return layer;
    }

    public clone()
    {
        var cloned = new BarcodeLayer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : BarcodeLayer)
    {
        layer.text = this._text;
        layer.barcodeType = this._barcodeType;
        layer.showNumber = this._showNumber;

        layer.keepRatio = this._keepRatio;

        super.cloneParameter(layer);
    }

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.text = this._text;
        jsonObject.barcodeType = this._barcodeType;
        jsonObject.showNumber = this._showNumber;

        jsonObject.keepRatio = this._keepRatio;

        jsonObject = super.saveParameterToJson(jsonObject);

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : BarcodeLayer
    {
        var layer = new BarcodeLayer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.text != null) { this._text = jsonData.text; }
        if(jsonData.barcodeType != null) { this._barcodeType = jsonData.barcodeType; }
        if(jsonData.showNumber != null) { this._showNumber = jsonData.showNumber; }

        if(jsonData.keepRatio != null) { this._keepRatio = jsonData.keepRatio; }

        super.loadParameterFromJson(jsonData);
    }
}